import { defineMessage } from 'react-intl';

export const statusMessages = {
  all: defineMessage({
    id: `logger.status.filter.all`,
    defaultMessage: 'Todas',
  }),
  online: defineMessage({
    id: `logger.status.filter.online`,
    defaultMessage: 'Online',
  }),
  offline: defineMessage({
    id: `logger.status.filter.offline`,
    defaultMessage: 'Offline',
  }),
};

export enum StatusFilterType {
  ALL = 'all',
  ONLINE = 'online',
  OFFLINE = 'offline',
}

/** Filter values for station type: all, TV only, or Radio only. */
export enum StationTypeFilterType {
  ALL = 'all',
  TV = 'tv',
  RADIO = 'radio',
}
